module.exports = {
    myHost: {
       'host':'https://api-rdrc.catchbangladesh.com'
    }
};
